/* V-Tight 3.5 / mobile-first purchase experience. Compatible with Dawn 15.4.1. */
(() => {
  'use strict';
  const $ = (selector,root=document) => root.querySelector(selector);
  const $$ = (selector,root=document) => [...root.querySelectorAll(selector)];
  const rootPath = window.Shopify?.routes?.root || '/';
  const path = (fragment) => `${rootPath.replace(/\/$/,'')}${fragment}`;
  let adding = false;
  const navButton = $('[data-v34-menu-btn]');
  const nav = $('#v34-menu');
  const closeMenu = (restoreFocus = false) => {
    if(!nav || nav.hidden)return;
    nav.hidden = true;
    navButton?.setAttribute('aria-expanded','false');
    navButton?.setAttribute('aria-label','Menu openen');
    if(restoreFocus)navButton?.focus();
  };
  navButton?.addEventListener('click', () => {
    if(!nav)return;
    const opening=nav.hidden;
    nav.hidden = !opening;
    navButton.setAttribute('aria-expanded',String(opening));
    navButton.setAttribute('aria-label',opening?'Menu sluiten':'Menu openen');
  });
  nav?.addEventListener('click',e=>{if(e.target.closest('a'))closeMenu();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeMenu(true);});
  document.addEventListener('click',e=>{if(nav && !nav.hidden && !e.target.closest('.v34-header'))closeMenu();});
  window.addEventListener('resize',()=>{if(window.innerWidth > 860)closeMenu();},{passive:true});

  const selector = $('form[data-v34-selector]');
  if(selector){
    const reflectChoice = (radio) => {
      if(!radio) return;
      const id = $('[data-v34-form-id]',selector);
      if(id) id.value=radio.value;
      const text = (a,t) => {const el=$(a);if(el) el.textContent=t;};
      text('[data-v34-price]',radio.dataset.v34Price);
      text('[data-v34-btnprice]',radio.dataset.v34Price);
      text('[data-v34-unit]',radio.dataset.v34Unit+' / flacon');
      text('[data-v34-qty]',radio.dataset.v34Qty+(radio.dataset.v34Qty==='1'?' flacon':' flacons'));
      const chosenGallery=$(`[data-v35-pack-gallery="${radio.dataset.v34Qty}"]`);
      $$('[data-v35-pack-gallery]').forEach(g=>{g.hidden = g !== chosenGallery;});
      const photo=$('[data-v34-gallery-main] img');
      const firstThumb=chosenGallery?.querySelector('[data-v34-thumb]');
      const selectedURL=firstThumb?.dataset.url || radio.dataset.v34Img;
      if(photo && selectedURL){photo.src=selectedURL;photo.srcset='';photo.alt=firstThumb?.dataset.alt||radio.dataset.v34Name||'V-Tight verzorgingsgel';}
      if(chosenGallery) $$('[data-v34-thumb]',chosenGallery).forEach((b,i)=>{b.classList.toggle('is-active',i===0);b.setAttribute('aria-pressed',String(i===0));});
      const saving=$('[data-v35-saving]');if(saving){saving.textContent=radio.dataset.v35Saving||'';saving.hidden=!saving.textContent;}
      // Keep the central H1 constant across four packaging choices.
      $$('.v34-pack',selector).forEach(el=>el.classList.toggle('selected',el.contains(radio)));
      const stickyPrice=$('[data-v34-sticky-price]');if(stickyPrice)stickyPrice.textContent=radio.dataset.v34Price;
    };
    $$('input[name="v34-pack-choice"]',selector).forEach(radio=>radio.addEventListener('change',()=>reflectChoice(radio)));
    reflectChoice($('input[name="v34-pack-choice"]:checked',selector));
    // Native sticky purchase CTA, small and only shown once the main purchase area is off screen.
    const panel=$('.v34-buybox');
    if(panel){
      const sticky=document.createElement('div');sticky.className='v34-sticky-buy';sticky.hidden=true;
      sticky.innerHTML='<div><small>V-Tight · jouw keuze</small><strong data-v34-sticky-price></strong></div><button type="button" class="v34-btn v34-btn-primary">In winkelwagen →</button>';
      document.body.append(sticky);
      sticky.querySelector('button').addEventListener('click',()=>selector.requestSubmit());
      reflectChoice($('input[name="v34-pack-choice"]:checked',selector));
      let onScreen=true;
      const redraw=()=>{const bottom=panel.getBoundingClientRect().bottom;sticky.hidden=!(window.innerWidth<=700 && !onScreen && bottom < 0);};
      if('IntersectionObserver' in window){new IntersectionObserver(entries=>{onScreen=entries[0].isIntersecting;redraw();},{threshold:0}).observe(panel);}
      window.addEventListener('scroll',redraw,{passive:true});window.addEventListener('resize',redraw,{passive:true});
    }
  }
  // Original Shopify product gallery images only; avoid generated or substituted packaging shots.
  $$('[data-v34-thumb]').forEach(button=>button.addEventListener('click',()=>{
    const main=$('[data-v34-gallery-main] img');if(!main)return;
    main.src=button.dataset.url;main.srcset='';main.alt=button.dataset.alt||main.alt;
    const group=button.closest('[data-v35-pack-gallery]') || document;
    $$('[data-v34-thumb]',group).forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
  }));
  const toast = (()=>{
    let node;
    return (message,successful) => {
      if(!node){node=document.createElement('div');node.className='v34-toast';node.setAttribute('role','status');node.setAttribute('aria-live','polite');document.body.append(node);}
      node.innerHTML='';
      const label=document.createElement('strong');label.textContent=message;node.append(label);
      if(successful){const link=document.createElement('a');link.href=path('/cart');link.textContent='Bekijk winkelwagen →';node.append(link);}
      const close=document.createElement('button');close.type='button';close.setAttribute('aria-label','Sluiten');close.textContent='×';close.addEventListener('click',()=>node.classList.remove('active'));node.append(close);
      node.classList.add('active');clearTimeout(node.hideTimer);node.hideTimer=setTimeout(()=>node.classList.remove('active'),6500);
    };
  })();
  async function updateCartCount(){
    try{const r=await fetch(path('/cart.js'),{credentials:'same-origin'});if(!r.ok)return;const cart=await r.json();
      $$('[data-v34-cartcount]').forEach(el=>el.textContent=String(cart.item_count));
      $('[data-v34-cartlink]').forEach(el=>el.setAttribute('aria-label',`Winkelwagen met ${cart.item_count} artikelen`));
      return cart.item_count;
    }catch(e){console.warn('Cart count refresh failed',e);}
  }
  document.addEventListener('submit',async e=>{
    const form=e.target?.closest?.('form[data-v34-add]');if(!form)return;
    e.preventDefault();if(adding)return;
    const id=$('input[name="id"]',form)?.value;
    const note=$('[role="status"]',form);
    if(!/^\d+$/.test(id||'')){if(note)note.textContent='De gekozen verpakking is momenteel niet beschikbaar.';return;}
    const btn=$('button[type="submit"]',form);if(!btn||btn.disabled)return;
    adding=true;btn.disabled=true;const oldText=btn.innerHTML;btn.textContent='Toevoegen…';if(note)note.textContent='';
    try{
      const fd=new FormData(form);fd.delete('v34-pack-choice');fd.set('sections','cart-drawer');fd.set('sections_url',window.location.pathname);
      const resp=await fetch(path('/cart/add.js'),{method:'POST',body:fd,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
      const data=await resp.json();
      if(!resp.ok||data.status>=400)throw Error(data.description||data.message||'Toevoegen mislukt.');
      // Refresh the native cart drawer silently so the header bag always opens an up-to-date cart.
      const drawer=$('cart-drawer');
      const syncDrawer=(html)=>{
        if(!drawer || !html)return false;
        const fresh=new DOMParser().parseFromString(html,'text/html').querySelector('#CartDrawer');
        const current=drawer.querySelector('#CartDrawer');
        if(!fresh || !current)return false;
        current.innerHTML=fresh.innerHTML;
        drawer.classList.remove('is-empty');
        drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
        drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close());
        return true;
      };
      let synced=syncDrawer(data.sections?.['cart-drawer']);
      if(drawer && !synced) {
        try{
          const r=await fetch(path('/cart?sections=cart-drawer'),{credentials:'same-origin'});
          if(r.ok){const sections=await r.json();synced=syncDrawer(sections['cart-drawer']);}
        }catch(error){console.warn('Cart drawer refresh failed',error);}
      }
      const cartCount=await updateCartCount();
      document.dispatchEvent(new CustomEvent('vt35:cart-updated'));
      if(window.VTightCartConfirm?.show){
        window.VTightCartConfirm.show(data,{count:cartCount,trigger:btn});
      }else{
        toast('Toegevoegd aan je winkelwagen.',true);
      }
      if(note)note.textContent='Toegevoegd aan je winkelwagen.';
    }catch(err){const msg=err.message||'Er ging iets mis. Probeer het opnieuw.';if(note)note.textContent=msg;toast(msg,false);}
    finally{btn.innerHTML=oldText;btn.disabled=false;adding=false;}
  });
})();
